import { useState } from "react";

export const useBookingSnackbar = () => {
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [messageSnk, setMessageSnk] = useState("");

  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  return {
    stateSnk,
    vertical: "top",
    horizontal: "center",
    severity,
    messageSnk,
    handleSnkClose,
    snackBarDialog,
  };
};
